import { AiAssistantSettingsFormBean } from './AiAssistantSettingsForm.types';

export const formInitializer = (enabledByProvider: boolean) => (): AiAssistantSettingsFormBean => {
   return { enabled: enabledByProvider };
};
